var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#D49A68"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9303 15.5C24.9621 15.4291 24.977 15.3519 24.9739 15.2743H25C24.8882 12.6059 22.6849 10.5 20.0049 10.5C17.325 10.5 15.1217 12.6059 15.0099 15.2743C14.9967 15.349 14.9967 15.4253 15.0099 15.5H14.9317C13.6502 15.5 12.2803 16.346 11.8826 18.6201L11.1049 24.8147C10.4686 29.3629 12.8106 30.5 15.8685 30.5H24.1585C27.2075 30.5 29.4789 28.8535 28.9133 24.8147L28.1444 18.6201C27.676 16.4096 26.3503 15.5 25.0865 15.5H24.9303ZM23.4932 15.5C23.4654 15.4279 23.4506 15.3515 23.4497 15.2743C23.4497 13.3568 21.8899 11.8024 19.9657 11.8024C18.0416 11.8024 16.4818 13.3568 16.4818 15.2743C16.495 15.349 16.495 15.4253 16.4818 15.5H23.4932ZM17.097 20.6486C16.6089 20.6486 16.2132 20.2413 16.2132 19.7389C16.2132 19.2366 16.6089 18.8293 17.097 18.8293C17.5851 18.8293 17.9808 19.2366 17.9808 19.7389C17.9808 20.2413 17.5851 20.6486 17.097 20.6486ZM22.002 19.7389C22.002 20.2413 22.3977 20.6486 22.8858 20.6486C23.3739 20.6486 23.7696 20.2413 23.7696 19.7389C23.7696 19.2366 23.3739 18.8293 22.8858 18.8293C22.3977 18.8293 22.002 19.2366 22.002 19.7389Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashIcon4);
export default __webpack_public_path__ + "static/media/dash-icon-4.b03989f41f8471ff782f5197a3c1915a.svg";
export { ForwardRef as ReactComponent };